/** @file Takes the project out of the trash; the ProjectDO clears trashed_at in D1 when it commits this. */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';

export const command = defineCommand({
  name: 'project.restore',
  description: 'Restore a trashed project.',
  input: z.object({}).strict(),
  apply(draft, input, ctx) {
    draft.meta.updatedAt = ctx.now;
  },
});
